<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="login-field" type="text" v-checkenter="login" v-maska="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF" v-model="username">
        </div>
        <div class="field-wrapper" v-if="usePassword">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="password" v-checkenter="login" v-model="password" :placeholder="passwordPlaceholder ? passwordPlaceholder : 'Senha'">
        </div>
        <input class="login-button" type="button" :value="cta ? cta : 'ENTRAR'" @click.prevent="login">
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    import { maska } from 'maska';

    export default {
        name: 'CPFLogin',

        props: {
            usePassword: true,
            placeholder: null,
            passwordPlaceholder: '',
            cta: ''
        },

        directives: {
            maska
        },

        data ()
        {
            return {
                username: '',
                password: ''
            }
        },

        methods: {
            
            async login ()
            {
                this.username = this.username.toLowerCase().trim();
                this.password = this.password.trim();

                if (!this.usePassword) this.password = this.username;

                if (this.username && this.password)
                {
                    api
                        .post(`event/${this.$store.state.eventId}/loginCpf`, { password: await encrypt(this.password), cpf: this.username })
                        .then(response => {
                            this.$emit('logged', response);
                        })
                        .catch(err => {
                            this.$emit('error', 'fail');
                        });
                }
                else
                {
                    // show error
                    this.$emit('error', 'fail');
                }
            }
        }
        
    }
</script>

<style lang="scss">
    
</style>